import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MODAL_SIZES } from 'shared-modules/constants';
import { Button, Modal } from '../../../../components';
import styles from './runSuccess.module.scss';

const RunSuccess = ({ isOpen, closeModal, runNowResultsLogic, onClickButton }) => {
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} size={MODAL_SIZES.WIDTH_400} headerStyle={styles.modalHeader}>
      <div className={styles.iconContainer}>
        <i className={classNames('material-icons-outlined', styles.icon)}>task_alt</i>
      </div>
      <div className={styles.row}>{runNowResultsLogic.success.modalTitle}</div>
      <div className={styles.title}>{runNowResultsLogic.success.title}</div>

      <div className={styles.buttonWrapper}>
        <Button secondary onClick={onClickButton} className={classNames(styles.button)} width={320}>
          {runNowResultsLogic.buttons.submit.label}
        </Button>
      </div>
    </Modal>
  );
};

RunSuccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  runNowResultsLogic: PropTypes.shape({
    success: PropTypes.shape({
      modalTitle: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }).isRequired,
    buttons: PropTypes.shape({
      submit: PropTypes.shape({
        label: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  onClickButton: PropTypes.func.isRequired,
};

export default memo(RunSuccess);
